import Vue from "vue";
import axios from "axios";
import qs from "qs";
import { v4 as uuidv4 } from "uuid";
import { getStorage } from "@/utils/storage";
import generateTdMapKey from "@/utils/generateToken";
const { pathToRegexp } = require("path-to-regexp");

// 服务端返回的错误code 白名单接口
const responseWhiteList = [
  "/api/produce/co/farm/insure/order/add",
  "/api/user/co/company/get",
  "/api/produce/co/iotAccess/camera/list",
  "/api/produce/co/iotAccess/device/list",
  "/api/produce/co/iotAccess/device/detail",
  "/api/produce/co/farmRealTimeDynamic/listByFarmId",
];

// 创建axios实例
const service = axios.create({
  timeout: 20000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (config.url.indexOf("RemoteTokenServer") != -1) return config;
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.headers["clientType"] = "1";
    config.headers["platformType"] = "2";
    config.headers["requestId"] = uuidv4();
    config.headers["X-Platform"] = "govAdmin";
    const accessToken = getStorage("ACCESSTOKEN");
    if (accessToken) {
      config.headers.accesstoken = accessToken;
    }
    // 支付系统（STORY#3197）要求 companyId 放在请求头；其余系统沿用 body 传参，不影响既有接口
    // 优先用调用方在 config 上显式指定的 companyId，保证 header 与本次业务参数一致
    // （若只用本地缓存，在切换企业/URL 携带其他企业时会与 body 冲突，导致 42002 类鉴权错误）
    if (config.url && config.url.indexOf("/api/payment/") !== -1) {
      const farmInfo = getStorage("FARMINFO") || {};
      const companyInfo = getStorage("COMPANYINFO") || {};
      const companyId =
        config.companyId || farmInfo.companyId || companyInfo.companyId;
      if (companyId) {
        config.headers.companyId = companyId;
      }
    }
    return config;
  },
  (error) => ({ status: 0, msg: error.message })
);

// response拦截器
service.interceptors.response.use(
  (response) => {
    const res = response;
    let isWhite = false;
    for (const api of responseWhiteList.values()) {
      if (
        pathToRegexp(api, [], {
          start: true,
          end: false,
        }).test(res.config.url)
      ) {
        isWhite = true;
        break;
      }
    }
    // isWhite = true; 由前端自定义提示
    if (res.status === 200 && !isWhite) {
      switch (res.data.respCode) {
        case 0:
          return res.data;
        case 300:
        case 404:
          Vue.prototype.$message({
            message: res.data.respDesc,
            type: "warning",
          });
          break;
        case 400:
          // token无效
          // localStorage.clear();
          // router.push({ name: "Login" });
          break;
        case 401:
          // 无权限访问
          Vue.prototype.$message({
            message: res.data.respDesc,
            type: "warning",
          });
          // localStorage.clear();
          // router.push({ name: "NotAccess" });
          break;
        case 500:
          // 无权限访问
          Vue.prototype.$message({
            message: res.data.respDesc,
            type: "warning",
          });
          break;
        default:
          break;
      }
    }
    switch (res.status) {
      case 0: // 错误并提示
        if (!res.config.errorSelf) {
          //
        }
        break;
      case 1: // 成功返回数据
        break;
      case -1: // 暂不进行任何操作
        break;
      default:
        break;
    }
    return res.data;
  },
  (error) => {
    console.log("err" + error); // for debug
    switch (error.request.status) {
      case 401: // 无权限访问，需要登录
        return Promise.reject ? Promise.reject(error) : error;
      case 500: // 请求接口错误
        if (error.config.linkError) {
          //
        }
        Vue.prototype.$message({
          message: "系统服务崩溃啦",
          type: "error",
        });
        return Promise.reject ? Promise.reject(error) : error;
    }
    return Promise.reject ? Promise.reject(error) : error;
  }
);

export default service;

// gis
const gisService = axios.create({
  timeout: 3000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
  },
});
gisService.interceptors.request.use(
  (config) => {
    config.data = qs.stringify(config.data); // 转为formdata数据格式
    return config;
  },
  (error) => Promise.error(error)
);
gisService.interceptors.response.use(
  (response) => {
    const res = response;
    // isWhite = true; 由前端自定义提示
    if (res.status === 200) {
      return res.data;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
  }
);

// 天地图api
const tDGovService = axios.create({
  baseURL: "https://api.tianditu.gov.cn",
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  timeout: 20000, // 请求超时时间
});
tDGovService.interceptors.request.use(
  (config) => {
    if (!config.params) {
      config.params = {};
    }
    config.params["tk"] = generateTdMapKey();
    return config;
  },
  (error) => ({ status: 0, msg: error.message })
);
tDGovService.interceptors.response.use(
  (response) => {
    const res = response;
    if (res.status === 200) {
      return res.data;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
  }
);

export { gisService, tDGovService };
